var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 217.85",
    style: {
      enableBackground: "new 0 0 850 217.85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F2326;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 0,66.84 0.11,66.99 150.92,66.99 150.92,150.72 67.19,150.72 67.19,75.36 0.21,75.36 0.21,217.7  217.91,217.7 217.91,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.27,66.99V217.7h-66.99V0h217.7v142.34h-47.56l47.56,75.36h-98.88l-43.47-75.36V75.36H377v-8.37H293.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M699.28,67.19v150.72H632.3V0.21H850v142.34h-47.56L850,217.91h-98.88l-43.47-75.36V75.57h75.36v-8.37H699.28z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.3,0l-0.61,95.4l-122.3,122.3h-47.4V0l66.99,0v103.33L623.3,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5cdd7272d1f91072eb719c09361b8f92.svg";
export { ForwardRef as ReactComponent };